module.exports = __webpack_public_path__ + "static/media/Instagram.ac6760c1.svg";